import { render } from "./FormaPagamentoBtn.vue?vue&type=template&id=6082de27&scoped=true&ts=true"
import script from "./FormaPagamentoBtn.vue?vue&type=script&lang=ts"
export * from "./FormaPagamentoBtn.vue?vue&type=script&lang=ts"

import "./FormaPagamentoBtn.vue?vue&type=style&index=0&id=6082de27&scoped=true&lang=css"

import exportComponent from "/var/www/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6082de27"]])

export default __exports__